import { Wordmark } from "./Wordmark";
import { Link } from "@tanstack/react-router";
import { useI18n } from "@/i18n/I18nProvider";

export function FooterSection() {
  const { t } = useI18n();

  return (
    <>
      <link rel="stylesheet" href="https://pressranger.com/css/as-seen-in-widget.css" />
      <div className="as-seen-in-widget">
        <h3>As Seen In</h3>
        <div className="as-seen-in-logos-container">
          <div className="as-seen-in-rail"></div>
          <div className="as-seen-in-logos">
            <div className="as-seen-in-logo">
              <a
                href="https://markets.businessinsider.com/news/stocks/heallexa-launches-ai-powered-healthcare-directory-with-over-6-million-provider-profiles-to-make-finding-and-booking-care-more-convenient-1036190010"
                target="_blank"
                rel="noopener"
              >
                <img
                  src="https://pressranger.s3.us-west-1.amazonaws.com/2568852/NYLtGCeSk2eUFDxzqf55PW9MYbJhB8hGOe8BOgLw.png"
                  alt="Markets Insider"
                />
              </a>
            </div>
            <div className="as-seen-in-logo">
              <a
                href="https://finance.yahoo.com/sectors/healthcare/articles/heallexa-launches-ai-powered-healthcare-133100571.html"
                target="_blank"
                rel="noopener"
              >
                <img
                  src="https://pressranger.s3.us-west-1.amazonaws.com/2569636/Nv7hfiNFNGQVmQSTxEIuFjEHwI3K0AmvXtQDn827.png"
                  alt="Yahoo! Finance"
                />
              </a>
            </div>
            <div className="as-seen-in-logo">
              <a
                href="https://apnews.com/press-release/globenewswire-mobile/heallexa-launches-ai-powered-healthcare-directory-with-over-6-million-provider-profiles-to-make-finding-and-booking-care-more-convenient-1583f6cde84313ea4b7c7ad0a8bc53ef"
                target="_blank"
                rel="noopener"
              >
                <img
                  src="https://pressranger.s3.us-west-1.amazonaws.com/2569639/Zkf9zg616LrwoANxty7C0Bip4GBnL9nPC8ZCRktk.png"
                  alt="Associated Press"
                />
              </a>
            </div>
            <div className="as-seen-in-logo">
              <a
                href="https://www.benzinga.com/pressreleases/26/05/g52762425/heallexa-launches-ai-powered-healthcare-directory-with-over-6-million-provider-profiles-to-make-fi"
                target="_blank"
                rel="noopener"
              >
                <img
                  src="https://pressranger.s3.us-west-1.amazonaws.com/2569642/iXe71yZoeKdrgrbh8kfnh5uEUqNqHxnuuMbbTgc2.png"
                  alt="Benzinga"
                />
              </a>
            </div>
          </div>
          <div className="as-seen-in-rail right"></div>
        </div>
      </div>
      <footer className="relative block w-full border-t border-primary-foreground/10 bg-primary text-primary-foreground pb-[1px] mb-[-1px]">
      <div className="h-px w-full bg-gradient-to-r from-transparent via-primary-foreground/25 to-transparent"></div>
      <div className="mx-auto max-w-[1200px] px-6 py-10 flex flex-col gap-7">
        <nav
          aria-label="Footer navigation"
          className="flex flex-wrap items-center justify-center gap-x-7 gap-y-2 text-[13px] font-medium"
        >
          <Link
            to="/browse"
            className="text-primary-foreground/85 hover:text-primary-foreground transition-colors"
          >
            {t.footer.claim}
          </Link>
          <Link
            to="/specialties"
            className="text-primary-foreground/85 hover:text-primary-foreground transition-colors"
          >
            Specialties
          </Link>
          <Link
            to="/locations"
            className="text-primary-foreground/85 hover:text-primary-foreground transition-colors"
          >
            Locations
          </Link>
          <Link
            to="/blog"
            className="text-primary-foreground/85 hover:text-primary-foreground transition-colors"
          >
            Blog
          </Link>
          <Link
            to="/insurance"
            className="text-primary-foreground/85 hover:text-primary-foreground transition-colors"
          >
            Insurance
          </Link>
          <Link
            to="/compare"
            className="text-primary-foreground/85 hover:text-primary-foreground transition-colors"
          >
            Compare
          </Link>
          <Link
            to="/list-your-practice"
            className="text-primary-foreground/85 hover:text-primary-foreground transition-colors"
          >
            {t.nav.list}
          </Link>
        </nav>

        <div className="text-center max-w-[620px] mx-auto text-primary-foreground/75">
          <p className="text-[12px] font-semibold tracking-[0.02em] text-primary-foreground">
            Heallexa is a healthcare provider directory, not a medical practice.
          </p>
          <p className="mt-1 text-[11px] leading-relaxed text-primary-foreground/70">
            Use of this site does not create a doctor-patient relationship.
          </p>

          <ul className="mt-8 flex flex-wrap items-center justify-center gap-2 text-[11px] font-medium">
            <li>
              <span
                tabIndex={0}
                title="ID Verified"
                className="group inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-foreground/15 bg-primary-foreground/5 px-3 py-1 text-primary-foreground/85 transition-all duration-200 hover:border-primary-foreground/40 hover:bg-primary-foreground/15 hover:text-primary-foreground hover:-translate-y-px hover:shadow-[0_2px_10px_-2px_rgba(255,255,255,0.15)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-foreground/70 focus-visible:ring-offset-2 focus-visible:ring-offset-primary cursor-default"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-badge-check h-3.5 w-3.5 shrink-0 transition-transform duration-200 group-hover:scale-110"
                  aria-hidden="true"
                >
                  <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
                ID Verified
              </span>
            </li>
            <li>
              <span
                tabIndex={0}
                title="License Verified"
                className="group inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-foreground/15 bg-primary-foreground/5 px-3 py-1 text-primary-foreground/85 transition-all duration-200 hover:border-primary-foreground/40 hover:bg-primary-foreground/15 hover:text-primary-foreground hover:-translate-y-px hover:shadow-[0_2px_10px_-2px_rgba(255,255,255,0.15)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-foreground/70 focus-visible:ring-offset-2 focus-visible:ring-offset-primary cursor-default"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-scale h-3.5 w-3.5 shrink-0 transition-transform duration-200 group-hover:scale-110"
                  aria-hidden="true"
                >
                  <path d="M12 3v18" />
                  <path d="m19 8 3 8a5 5 0 0 1-6 0zV7" />
                  <path d="M3 7h1a17 17 0 0 0 8-2 17 17 0 0 0 8 2h1" />
                  <path d="m5 8 3 8a5 5 0 0 1-6 0zV7" />
                  <path d="M7 21h10" />
                </svg>
                License Verified
              </span>
            </li>
            <li>
              <span
                tabIndex={0}
                title="Secure Payments"
                className="group inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-foreground/15 bg-primary-foreground/5 px-3 py-1 text-primary-foreground/85 transition-all duration-200 hover:border-primary-foreground/40 hover:bg-primary-foreground/15 hover:text-primary-foreground hover:-translate-y-px hover:shadow-[0_2px_10px_-2px_rgba(255,255,255,0.15)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-foreground/70 focus-visible:ring-offset-2 focus-visible:ring-offset-primary cursor-default"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-lock h-3.5 w-3.5 shrink-0 transition-transform duration-200 group-hover:scale-110"
                  aria-hidden="true"
                >
                  <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
                Secure Payments
              </span>
            </li>
          </ul>
        </div>

        <div className="h-px w-full bg-primary-foreground/10 mt-2"></div>
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-[12px] text-primary-foreground/70">
          <Wordmark variant="inverse" className="text-lg" aria-label="Heallexa home" />
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1">
            <p>&copy; {new Date().getFullYear()} Heallexa Inc.</p>
            <span
              aria-hidden="true"
              className="h-3 w-px bg-primary-foreground/25 hidden sm:block"
            ></span>
            <Link
              to="/terms"
              className="hover:text-primary-foreground transition-colors"
            >
              Terms
            </Link>
            <Link
              to="/privacy"
              className="hover:text-primary-foreground transition-colors"
            >
              Privacy
            </Link>
          </div>
          <ul
            className="flex items-center gap-2"
            aria-label="Heallexa on social media"
          >
            <li>
              <a
                href="https://www.linkedin.com/company/heallexa"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-primary-foreground/15 bg-primary-foreground/5 text-primary-foreground/85 transition-all duration-200 hover:border-primary-foreground/40 hover:bg-primary-foreground/15 hover:text-primary-foreground hover:-translate-y-px"
              >
                <svg
                  viewBox="0 0 24 24"
                  className="h-3.5 w-3.5"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.36V9h3.41v1.56h.05c.47-.9 1.63-1.85 3.36-1.85 3.6 0 4.27 2.37 4.27 5.45v6.29zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0z" />
                </svg>
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/heallexa"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-primary-foreground/15 bg-primary-foreground/5 text-primary-foreground/85 transition-all duration-200 hover:border-primary-foreground/40 hover:bg-primary-foreground/15 hover:text-primary-foreground hover:-translate-y-px"
              >
                <svg
                  viewBox="0 0 24 24"
                  className="h-3.5 w-3.5"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.09 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.69 4.53-4.69 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.96.93-1.96 1.89v2.26h3.33l-.53 3.49h-2.8V24C19.61 23.09 24 18.1 24 12.07z" />
                </svg>
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/heallexa"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-primary-foreground/15 bg-primary-foreground/5 text-primary-foreground/85 transition-all duration-200 hover:border-primary-foreground/40 hover:bg-primary-foreground/15 hover:text-primary-foreground hover:-translate-y-px"
              >
                <svg
                  viewBox="0 0 24 24"
                  className="h-3.5 w-3.5"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.71 3.71 0 0 1-1.38-.9 3.71 3.71 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23-.06-1.27-.07-1.65-.07-4.85s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41 1.27-.06 1.65-.07 4.85-.07M12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63c-.79.3-1.46.72-2.13 1.39A5.9 5.9 0 0 0 .63 4.14C.33 4.9.13 5.78.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91.3.79.72 1.46 1.39 2.13.67.67 1.34 1.09 2.13 1.39.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56.79-.3 1.46-.72 2.13-1.39.67-.67 1.09-1.34 1.39-2.13.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91-.3-.79-.72-1.46-1.39-2.13A5.9 5.9 0 0 0 19.86.63c-.76-.3-1.64-.5-2.91-.56C15.67.01 15.26 0 12 0zm0 5.84a6.16 6.16 0 1 0 0 12.32 6.16 6.16 0 0 0 0-12.32zm0 10.16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.4-11.85a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88z" />
                </svg>
              </a>
            </li>
            <li>
              <a
                href="https://x.com/heallexahq"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X (Twitter)"
                className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-primary-foreground/15 bg-primary-foreground/5 text-primary-foreground/85 transition-all duration-200 hover:border-primary-foreground/40 hover:bg-primary-foreground/15 hover:text-primary-foreground hover:-translate-y-px"
              >
                <svg
                  viewBox="0 0 24 24"
                  className="h-3.5 w-3.5"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
    </>
  );
}
